
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeGenericFilled as ObiVesselTypeGenericFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-generic-filled.js';
 
 
 

 
 export const ObiVesselTypeGenericFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-type-generic-filled',
   elementClass: ObiVesselTypeGenericFilledElement,
   events: {
     
   }
  });
 
 